import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { ItemsService } from "src/app/services/items.service";
import { EnumService } from "../services/enum.service";
import { EcommService } from "src/app/services/ecomm.service";
import { constApi } from "src/environments/constApi";
import { NgxSpinnerService } from "ngx-spinner";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-blog-section-group-six",
  templateUrl: "./blog-section-group-six.component.html",
  styleUrls: ["./blog-section-group-six.component.sass"],
})
export class BlogSectionGroupSixComponent implements OnInit {
  constructor(
    private enumService: EnumService,
    private router: Router,
    private itemService: ItemsService,
    private ecomService: EcommService,
    private spinner: NgxSpinnerService
  ) {}
  bannerContent: any[] = [];
  bannerList: any[] = [];
  contenedor: any[] = [];
  esMovil: boolean;
  ngOnInit() {
    let contador: any = 0;
    let banner: any[] = [];

    this.enumService.getBannerBPG4().subscribe(async (resp: any) => {
      this.contenedor = resp.filter(x => x.Habilitado == true);
    });
  }
  async irAProductos(item) {
    if (item.idItemEC == null) {
      if (item.Marca.length == 0) {
        this.router.navigate([
          "/home/products",
          item.Codigo,
          0,
          0,
          "TODAS",
          0,
          0,
          1,
        ]);
      } else {
        this.router.navigate([
          "/home/products",
          item.Codigo,
          0,
          0,
          item.Marca,
          0,
          0,
          1,
        ]);
      }
    } else {
      if (item.AccionBanner == "CATALOGO") {
        this.router.navigate([
          "/home/products",
          item.Codigo,
          0,
          0,
          "TODAS",
          0,
          0,
          1,
        ]);
      } else {
        this.spinner.show();
        await this.itemService.sumarClic(item.idItemEC);
        this.spinner.hide();
        this.router.navigate(["/home/product", item.idItemEC]);
      }
    }
  }
  async buscarItem(param: any) {
    return await this.ecomService
      .getParam(environment.apiUrl,constApi.ITEMSLIST, param)
      .toPromise()
      .catch((error: any) => {
        this.spinner.hide();
      });
  }
  ngDoCheck() {
    let tamaño = window.innerWidth;
    if (tamaño <= 1000) {
      this.esMovil = true;
    } else {
      this.esMovil = false;
    }
  }
}
